import { TellescopeModelFromName } from "@tellescope/tanstack-query";
import { FormResponseValueAnswer } from "@tellescope/types-models";
import { discriminatedStringUnionIncludes } from "@tellescope/utils";

const REPEATABLE_TYPES = ["string", "stringLong", "number"] as const;

export interface IsRepeatMismatchArgs {
  field: Pick<TellescopeModelFromName<"form_fields">, "type" | "options" | "isOptional">;
  value: FormResponseValueAnswer["value"];
  confirmation: string;
}

/**
 * Whether a repeat ("confirm your entry") field's two inputs disagree.
 *
 * An optional field whose both inputs are still empty is never a mismatch — skipping it there is
 * what keeps an untouched optional repeat pair from blocking Next, matching legacy
 * (`hooks.tsx:1108`). Once either input has content the comparison applies, so a stray confirmation
 * against an empty primary is still surfaced rather than silently accepted.
 */
export const isRepeatMismatch = ({ field, value, confirmation }: IsRepeatMismatchArgs): boolean => {
  if (!field.options?.repeat) return false;
  if (!discriminatedStringUnionIncludes(REPEATABLE_TYPES, field.type)) return false;

  const primary = typeof value === "string" ? value : typeof value === "number" ? String(value) : "";
  if (field.isOptional && !primary && !confirmation) return false;

  return primary !== confirmation;
};
